import posthog from "posthog-js";

const token = process.env.NEXT_PUBLIC_POSTHOG_PROJECT_TOKEN;

// Only initialize when the token is baked into the build. In dev without the
// token (e.g., a fresh checkout) PostHog stays inert instead of throwing.
if (token) {
  posthog.init(token, {
    // Reverse-proxy via /ingest so adblockers don't intercept (most filter
    // lists block i.posthog.com / cloud-eu.i.posthog.com directly). The
    // rewrites in next.config.ts forward /ingest/* to eu.i.posthog.com.
    api_host: "/ingest",
    ui_host: process.env.NEXT_PUBLIC_POSTHOG_HOST ?? "https://eu.i.posthog.com",
    defaults: "2026-01-30",

    // Don't create a billable person profile for every anonymous landing
    // visitor — only once they're identified (posthog.identify on signup).
    // Anonymous events still merge onto the person at identify time, so the
    // full funnel (anonymous → signup → conversion) is preserved.
    person_profiles: "identified_only",

    // Autocapture creates a flood of click events on a marketing site;
    // funnels come from the manual trackEvent dual-fire instead.
    autocapture: false,

    // Session replay OFF by default. With ~1000 visitors/day the free tier
    // (5K replays/month) burns fast and most page views are browse-noise.
    // `<PosthogRouteGuard/>` opts in selectively: it calls
    // posthog.startSessionRecording() only on high-intent journeys (the
    // Zenyra chat, /teste tests, /gaseste-terapeut questionnaire,
    // #DăMaiDeparte). Funnels still fire everywhere via the dual-fired
    // trackEvent — those are cheap and don't depend on recording.
    disable_session_recording: true,
    session_recording: {
      maskAllInputs: true,
    },

    capture_exceptions: true,
    debug: process.env.NODE_ENV === "development",
  });
} else if (process.env.NODE_ENV === "development") {
  // eslint-disable-next-line no-console
  console.warn(
    "[posthog] NEXT_PUBLIC_POSTHOG_PROJECT_TOKEN not set — analytics disabled",
  );
}
